import {
  useState,
  useEffect
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Stack
} from '@chakra-ui/react'
import {
  deleteFilter,
  usersSelectors
} from 'store'

import { FilterItem } from './FilterItem'
import { StyledFiltersContainer } from './styled'

export const FiltersData = () => {
  const dispatch = useDispatch()
  const {
    filters,
    isOpenRightModal
  } = useSelector(usersSelectors)
  const [animateToLeft, setAnimateToLeft] = useState(false)

  const deleteSearchBarFilter = (id) => dispatch(deleteFilter(id))

  useEffect(() => {
    // Used for the timing of animation to left relative to drawers/modals which opens from right
    setAnimateToLeft(isOpenRightModal)
  }, [isOpenRightModal])

  return (
    <Stack className="filter-data">
      <StyledFiltersContainer
        isOpenRightModal={animateToLeft}
        name="affinities_list"
      >
        {filters.map((item) => (
          <FilterItem
            deleteSearchBarFilter={deleteSearchBarFilter}
            item={item}
            key={item.id}
            length={filters?.length}
          />
        ))}
      </StyledFiltersContainer>
    </Stack>
  )
}
